export enum ERole {
  ADMIN = "admin",
  COMPANY = "company",
  USER = "user",
  POLICE = "POLICE",
  OPERATOR = "OPERATOR",
}
